import {
    Loading,
} from '@carbon/react';

import styles from './Interactions.module.scss';

import ItemEnable from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/ItemEnable/ItemEnable';
import RemoveTeamMember from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/RemoveTeamMember/RemoveTeamMember';
import ViewTeamMemberButton from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/ViewTeamMemberButton';
import AddOrRemovePoints from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/AddOrRemovePoints/AddOrRemovePoints';
import useGetUserPermission from 'hooks/useGetUserPermission';
import TransferOwnershipModal from '../TransferOwnershipModal/TransferOwnershipModal';
import { UserRole } from 'api/dtos/user';

type Props = {
    id: string;
    role: UserRole;
    enabled: boolean;
    canTransferOwnership: boolean;
    onViewDetails?: (id: string) => void;
    isLoading?: boolean;
    isActive?: boolean;
}

const Interactions = ({
    id,
    role,
    enabled,
    canTransferOwnership,
    onViewDetails,
    isLoading,
    isActive = true,
}: Props) => {
    const { isAdmin, isOwner } = useGetUserPermission();

    return (
        <>
            <div className={styles.container}>
                <div className={styles.innerContainer}>
                    {isActive && <ItemEnable disabled={(!isAdmin && !isOwner)} id={id} enabled={enabled} />}
                    <RemoveTeamMember id={id} role={role} />
                    <ViewTeamMemberButton id={id} onViewDetails={onViewDetails} />
                    <AddOrRemovePoints teamMemberId={id} />
                    <TransferOwnershipModal id={id} canTransferOwnership={canTransferOwnership} />
                </div>
            </div>
            {isLoading && <Loading />}
        </>
    );
};

export default Interactions;
